export interface EventoEnVivo {
  id: string;
  titulo: string;
  tipo: 'entrevista' | 'concierto' | 'cobertura' | 'festival' | 'especial';
  descripcion: string;
  fecha: string;
  hora: string;
  radioNombre: string;
  radioFrecuencia: string;
  radioLogo: string;
  locutorNombre: string;
  locutorAvatar: string;
  ciudad: string;
  pais: string;
  imagenUrl: string;
  cuentaRegresiva: string;
  estado: 'proximamente' | 'hoy' | 'en-vivo' | 'finalizado';
  participantes: number;
  compartidos: number;
  comentarios: number;
  score: {
    asistir: number;
    compartir: number;
    comentar: number;
    invitar: number;
  };
  esDestacado: boolean;
  tags: string[];
  programaNombre?: string;
}

export const tiposEventoEnVivo = [
  { id: 'entrevista' as const, label: 'Entrevista', icon: 'ri-mic-line', color: 'text-rose-600', bg: 'bg-rose-50', dot: 'bg-rose-500' },
  { id: 'concierto' as const, label: 'Concierto', icon: 'ri-music-2-line', color: 'text-amber-600', bg: 'bg-amber-50', dot: 'bg-amber-500' },
  { id: 'cobertura' as const, label: 'Cobertura', icon: 'ri-live-line', color: 'text-emerald-600', bg: 'bg-emerald-50', dot: 'bg-emerald-500' },
  { id: 'festival' as const, label: 'Festival', icon: 'ri-star-line', color: 'text-violet-600', bg: 'bg-violet-50', dot: 'bg-violet-500' },
  { id: 'especial' as const, label: 'Especial', icon: 'ri-sparkling-line', color: 'text-sky-600', bg: 'bg-sky-50', dot: 'bg-sky-500' },
];

export const estadosEventoEnVivo = [
  { id: 'proximamente' as const, label: 'Próximamente', color: 'text-foreground-600', bg: 'bg-background-200' },
  { id: 'hoy' as const, label: 'Hoy', color: 'text-red-600', bg: 'bg-red-50' },
  { id: 'en-vivo' as const, label: 'En Vivo Ahora', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { id: 'finalizado' as const, label: 'Finalizado', color: 'text-foreground-400', bg: 'bg-background-100' },
];

export const eventosEnVivo: EventoEnVivo[] = [
  {
    id: 'eev-1',
    titulo: 'Entrevista Exclusiva: Valentina Ríos — Detrás del Micrófono',
    tipo: 'entrevista',
    descripcion: 'Una entrevista íntima con Valentina Ríos, la locutora más escuchada del dial RFW. Conoceremos su historia, sus inicios en la radio, sus momentos más emotivos al aire y cómo construyó la comunidad más grande de oyentes. Los oyentes podrán enviar preguntas en vivo desde la Cabina.',
    fecha: '2026-06-22',
    hora: '18:00 CST',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=eev-logo-capital&orientation=squarish',
    locutorNombre: 'Valentina Ríos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%2C%20warm%20confident%20smile%2C%20modern%20studio%20headphones%2C%20broadcast%20booth%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=120&height=120&seq=eev-avatar-vrios&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Intimate%20radio%20interview%20studio%20scene%20with%20warm%20amber%20lighting%2C%20professional%20broadcast%20microphone%20on%20desk%2C%20cozy%20interview%20setup%20with%20two%20chairs%2C%20acoustic%20panels%20on%20walls%2C%20behind%20the%20scenes%20radio%20station%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows&width=1600&height=900&seq=eev-img-entrevista&orientation=landscape',
    cuentaRegresiva: '1 día',
    estado: 'proximamente',
    participantes: 1847,
    compartidos: 623,
    comentarios: 412,
    score: { asistir: 30, compartir: 15, comentar: 10, invitar: 20 },
    esDestacado: true,
    tags: ['locutora', 'detrás de escena', 'comunidad'],
    programaNombre: 'Tardes con Vale',
  },
  {
    id: 'eev-2',
    titulo: 'Summer Fest RFW 2026 — Transmisión en Vivo',
    tipo: 'festival',
    descripcion: 'El festival más esperado del año llega a RFW. 12 horas de música en vivo con 8 bandas, entrevistas backstage, sorteos exclusivos y cobertura total desde el Parque Metropolitano. Transmisión simultánea por RFW Radio y RFW TV. Los oyentes VIP tienen acceso a zona exclusiva.',
    fecha: '2026-07-15',
    hora: '11:00 CST',
    radioNombre: 'Radio Nueva Actitud',
    radioFrecuencia: '102.5 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20station%20square%20logo%2C%20minimalist%20sunburst%20icon%2C%20warm%20golden%20and%20coral%20emblem%2C%20clean%20elegant%20vector&width=120&height=120&seq=eev-logo-actitud&orientation=squarish',
    locutorNombre: 'Natalia Campos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20radio%20host%20portrait%2C%20warm%20friendly%20smile%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20plants%2C%20natural%20golden%20lighting&width=120&height=120&seq=eev-avatar-ncampos&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Massive%20summer%20music%20festival%20at%20outdoor%20park%20venue%2C%20multiple%20stages%20with%20colorful%20concert%20lights%2C%20huge%20energetic%20crowd%20at%20golden%20hour%2C%20confetti%20and%20fireworks%20in%20the%20sky%2C%20festival%20flags%20and%20banners%2C%20wide%20angle%20dynamic%20event%20photography%2C%20warm%20festive%20atmosphere&width=1600&height=900&seq=eev-img-summerfest&orientation=landscape',
    cuentaRegresiva: '24 días',
    estado: 'proximamente',
    participantes: 12580,
    compartidos: 4520,
    comentarios: 2187,
    score: { asistir: 50, compartir: 25, comentar: 15, invitar: 30 },
    esDestacado: true,
    tags: ['festival', 'música en vivo', 'VIP', 'verano'],
  },
  {
    id: 'eev-3',
    titulo: 'Cobertura Especial: Final del Campeonato Nacional',
    tipo: 'cobertura',
    descripcion: 'Cobertura total en vivo desde el Estadio Nacional. Previa con análisis táctico, transmisión minuto a minuto del partido, reacciones en tiempo real desde la Cabina, y post-partido con entrevistas a los protagonistas. Participá con tus comentarios y predicciones.',
    fecha: '2026-06-28',
    hora: '16:00 CST',
    radioNombre: 'Deportes Total Radio',
    radioFrecuencia: '101.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20square%20logo%2C%20soccer%20ball%20and%20microphone%20icon%2C%20bold%20blue%20and%20gold%20emblem%2C%20dynamic%20flat%20vector%20style&width=120&height=120&seq=eev-logo-deportes&orientation=squarish',
    locutorNombre: 'Javier Solís',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20sports%20commentator%20portrait%2C%20professional%20headset%2C%20enthusiastic%20expression%2C%20broadcast%20booth%2C%20blue%20lighting&width=120&height=120&seq=eev-avatar-jsolis&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20panoramic%20view%20during%20championship%20final%2C%20packed%20crowd%20with%20team%20colors%20and%20flags%2C%20dramatic%20stadium%20lighting%20at%20dusk%2C%20broadcast%20commentary%20booth%20overlooking%20the%20field%2C%20intense%20sports%20atmosphere%2C%20professional%20sports%20photography&width=1600&height=900&seq=eev-img-final&orientation=landscape',
    cuentaRegresiva: '7 días',
    estado: 'proximamente',
    participantes: 8921,
    compartidos: 3190,
    comentarios: 5643,
    score: { asistir: 40, compartir: 20, comentar: 15, invitar: 25 },
    esDestacado: true,
    tags: ['deportes', 'fútbol', 'final', 'estadio'],
    programaNombre: 'Carrusel Deportivo',
  },
  {
    id: 'eev-4',
    titulo: 'Concierto Acústico: Andrés Castillo Unplugged',
    tipo: 'concierto',
    descripcion: 'Una noche íntima de rock acústico con Andrés Castillo, locutor de Rock Total Radio. Versiones unplugged de clásicos del rock, historias detrás de las canciones, y un set especial de covers pedidos por los oyentes. Transmisión en vivo por RFW Radio con video por RFW TV.',
    fecha: '2026-07-08',
    hora: '20:00 CST',
    radioNombre: 'Rock Total Radio',
    radioFrecuencia: '95.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20square%20logo%2C%20electric%20guitar%20silhouette%2C%20bold%20red%20and%20black%20emblem%2C%20grunge%20style%20flat%20vector&width=120&height=120&seq=eev-logo-rock&orientation=squarish',
    locutorNombre: 'Andrés Castillo',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Rock%20radio%20host%20male%20portrait%2C%20leather%20jacket%2C%20confident%20expression%2C%20studio%20with%20guitars%20on%20wall%2C%20edgy%20lighting&width=120&height=120&seq=eev-avatar-acastillo&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20concert%20venue%20with%20warm%20amber%20stage%20lighting%2C%20acoustic%20guitar%20on%20stand%2C%20vintage%20microphone%2C%20small%20cozy%20audience%20seating%2C%20brick%20wall%20background%2C%20candles%20and%20warm%20atmosphere%2C%20editorial%20music%20photography&width=1600&height=900&seq=eev-img-acustico&orientation=landscape',
    cuentaRegresiva: '17 días',
    estado: 'proximamente',
    participantes: 3245,
    compartidos: 1187,
    comentarios: 876,
    score: { asistir: 35, compartir: 20, comentar: 10, invitar: 25 },
    esDestacado: true,
    tags: ['rock', 'acústico', 'íntimo', 'unplugged'],
  },
  {
    id: 'eev-5',
    titulo: 'Especial de Medianoche: Noche de Leyendas Urbanas',
    tipo: 'especial',
    descripcion: 'Un especial de 3 horas dedicado a las leyendas urbanas más escalofriantes de Centroamérica. Narraciones inmersivas con efectos de sonido, testimonios de oyentes en vivo, y un concurso de la mejor historia original. Prepará tus auriculares y apagá las luces.',
    fecha: '2026-06-22',
    hora: '22:00 CST',
    radioNombre: 'La Kalle 99.9',
    radioFrecuencia: '99.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20square%20logo%2C%20neon%20microphone%20icon%2C%20vibrant%20pink%20and%20coral%20emblem%2C%20modern%20flat%20vector&width=120&height=120&seq=eev-logo-kalle&orientation=squarish',
    locutorNombre: 'Diego Montenegro',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20male%20pop%20radio%20DJ%20portrait%2C%20stylish%20casual%20outfit%2C%20energetic%20smile%2C%20neon%20lit%20studio%20background%2C%20modern%20vibe&width=120&height=120&seq=eev-avatar-dmontenegro&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Eerie%20midnight%20radio%20studio%20with%20dim%20blue%20and%20purple%20atmospheric%20lighting%2C%20vintage%20microphone%20on%20desk%2C%20shadow%20play%20on%20walls%2C%20mysterious%20fog%20effect%2C%20spooky%20storytelling%20atmosphere%2C%20cinematic%20horror%20photography%20style&width=1600&height=900&seq=eev-img-leyendas&orientation=landscape',
    cuentaRegresiva: '1 día',
    estado: 'proximamente',
    participantes: 4521,
    compartidos: 2340,
    comentarios: 1892,
    score: { asistir: 25, compartir: 20, comentar: 15, invitar: 15 },
    esDestacado: true,
    tags: ['terror', 'leyendas', 'medianoche', 'concurso'],
  },
  {
    id: 'eev-6',
    titulo: 'Cobertura: Desfile de las Flores 2026',
    tipo: 'cobertura',
    descripcion: 'Cobertura completa del Desfile de las Flores desde el Paseo Colón. Equipo móvil reportando cada carroza, entrevistas con los artistas florales, y transmisión en vivo de todo el recorrido. Los oyentes pueden votar por su carroza favorita.',
    fecha: '2026-07-20',
    hora: '10:00 CST',
    radioNombre: 'Radio Cultural CR',
    radioFrecuencia: '94.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Cultural%20radio%20station%20square%20logo%2C%20book%20and%20flower%20icon%2C%20elegant%20teal%20and%20gold%20emblem%2C%20classic%20flat%20vector%20style&width=120&height=120&seq=eev-logo-cultural&orientation=squarish',
    locutorNombre: 'Mariana Vega',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20cultural%20radio%20host%20portrait%2C%20elegant%20warm%20smile%2C%20sophisticated%20casual%20style%2C%20artsy%20studio%20background%2C%20soft%20natural%20lighting&width=120&height=120&seq=eev-avatar-mvega&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Colorful%20flower%20parade%20on%20city%20avenue%2C%20elaborate%20floral%20floats%20with%20vibrant%20arrangements%2C%20crowd%20along%20the%20street%2C%20sunny%20festive%20day%20atmosphere%2C%20cultural%20celebration%20photography%2C%20wide%20angle%20street%20view&width=1600&height=900&seq=eev-img-desfile&orientation=landscape',
    cuentaRegresiva: '29 días',
    estado: 'proximamente',
    participantes: 3150,
    compartidos: 987,
    comentarios: 654,
    score: { asistir: 20, compartir: 15, comentar: 10, invitar: 10 },
    esDestacado: false,
    tags: ['cultura', 'desfile', 'flores', 'tradición'],
  },
  {
    id: 'eev-7',
    titulo: 'Entrevista: Carlos Mendoza — 20 Años en la Radio',
    tipo: 'entrevista',
    descripcion: 'Celebramos dos décadas de trayectoria de Carlos Mendoza, la voz icónica de Banda Radio MX. Recorrido por su carrera, los momentos que marcaron la radio regional, anécdotas inéditas y sorpresas de colegas y oyentes que lo admiran.',
    fecha: '2026-06-25',
    hora: '15:00 CST',
    radioNombre: 'Banda Radio MX',
    radioFrecuencia: '107.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Mexican%20banda%20radio%20station%20square%20logo%2C%20trumpet%20and%20drum%20icon%2C%20bold%20red%20green%20white%20emblem%2C%20festive%20flat%20vector%20style&width=120&height=120&seq=eev-logo-banda&orientation=squarish',
    locutorNombre: 'Carlos Mendoza',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Mexican%20male%20radio%20host%20portrait%2C%20traditional%20style%2C%20warm%20smile%2C%20festive%20studio%20background%2C%20natural%20lighting&width=120&height=120&seq=eev-avatar-cmendoza&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Veteran%20radio%20host%20in%20warm%20studio%20setting%2C%20wall%20of%20career%20memorabilia%20and%20photos%20behind%2C%20vintage%20radio%20equipment%20mixed%20with%20modern%20gear%2C%20golden%20anniversary%20atmosphere%2C%20nostalgic%20documentary%20photography%20style&width=1600&height=900&seq=eev-img-aniversario&orientation=landscape',
    cuentaRegresiva: '4 días',
    estado: 'proximamente',
    participantes: 2134,
    compartidos: 765,
    comentarios: 543,
    score: { asistir: 25, compartir: 15, comentar: 10, invitar: 15 },
    esDestacado: false,
    tags: ['aniversario', 'trayectoria', 'regional'],
  },
  {
    id: 'eev-8',
    titulo: 'Especial: Maratón de Éxitos 90s — 8 Horas Sin Parar',
    tipo: 'especial',
    descripcion: 'Ocho horas continuas de los mejores éxitos de los 90s. Sin comerciales, sin pausas. Cada hora un bloque temático: pop, rock, dance, baladas, latin hits. Los oyentes votan las canciones y el top 10 se define en vivo. Preparate para un viaje en el tiempo.',
    fecha: '2026-07-05',
    hora: '14:00 CST',
    radioNombre: 'Radio Nueva Actitud',
    radioFrecuencia: '102.5 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20station%20square%20logo%2C%20minimalist%20sunburst%20icon%2C%20warm%20golden%20and%20coral%20emblem%2C%20clean%20elegant%20vector&width=120&height=120&seq=eev-logo-actitud2&orientation=squarish',
    locutorNombre: 'Natalia Campos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20radio%20host%20portrait%2C%20warm%20friendly%20smile%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20plants%2C%20natural%20golden%20lighting&width=120&height=120&seq=eev-avatar-ncampos2&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Retro%2090s%20themed%20radio%20studio%20with%20neon%20colors%20and%20vintage%20cassette%20tapes%2C%20boombox%20and%20CD%20player%20props%2C%20colorful%20disco%20ball%20reflections%2C%20nostalgic%20music%20atmosphere%2C%20vibrant%20fun%20photography&width=1600&height=900&seq=eev-img-maraton90s&orientation=landscape',
    cuentaRegresiva: '14 días',
    estado: 'proximamente',
    participantes: 6734,
    compartidos: 2890,
    comentarios: 1567,
    score: { asistir: 35, compartir: 20, comentar: 15, invitar: 20 },
    esDestacado: true,
    tags: ['90s', 'maratón', 'nostalgia', 'votación'],
  },
  {
    id: 'eev-9',
    titulo: 'Concierto en Vivo: Banda Sinfónica Nacional',
    tipo: 'concierto',
    descripcion: 'La Banda Sinfónica Nacional se presenta en vivo desde el Teatro Nacional. Un repertorio especial que fusiona música clásica con ritmos latinoamericanos. Transmisión en alta definición por RFW TV y audio inmersivo por RFW Radio.',
    fecha: '2026-07-12',
    hora: '19:00 CST',
    radioNombre: 'Radio Vida Nueva',
    radioFrecuencia: '93.7 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20peaceful%20square%20logo%2C%20cross%20silhouette%20with%20sunrise%2C%20soft%20blue%20and%20white%20spiritual%20emblem%2C%20clean%20flat%20vector&width=120&height=120&seq=eev-logo-vida&orientation=squarish',
    locutorNombre: 'Pastor Daniel',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20pastor%20radio%20host%20portrait%2C%20kind%20warm%20expression%2C%20professional%20casual%2C%20serene%20studio%20background%2C%20soft%20natural%20lighting&width=120&height=120&seq=eev-avatar-pdaniel&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=National%20theater%20concert%20hall%20with%20symphony%20orchestra%20on%20stage%2C%20dramatic%20golden%20chandelier%20lighting%2C%20elegant%20architecture%2C%20musicians%20in%20formal%20attire%2C%20classical%20concert%20atmosphere%2C%20refined%20cultural%20photography&width=1600&height=900&seq=eev-img-sinfonica&orientation=landscape',
    cuentaRegresiva: '21 días',
    estado: 'proximamente',
    participantes: 1890,
    compartidos: 567,
    comentarios: 321,
    score: { asistir: 30, compartir: 15, comentar: 10, invitar: 20 },
    esDestacado: false,
    tags: ['clásica', 'sinfónica', 'teatro', 'cultural'],
  },
  {
    id: 'eev-10',
    titulo: 'Cobertura: Elecciones 2026 — Resultados en Vivo',
    tipo: 'cobertura',
    descripcion: 'Cobertura especial de la noche electoral. Resultados en tiempo real, análisis con expertos, conexiones con corresponsales en todo el país, y debate abierto en la Cabina. La información más completa y verificada del proceso electoral.',
    fecha: '2026-06-29',
    hora: '17:00 CST',
    radioNombre: 'Radio Noticias CR',
    radioFrecuencia: '91.5 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=News%20radio%20station%20square%20logo%2C%20microphone%20and%20globe%20icon%2C%20bold%20navy%20and%20red%20emblem%2C%20authoritative%20flat%20vector%20style&width=120&height=120&seq=eev-logo-noticias&orientation=squarish',
    locutorNombre: 'Roberto Sánchez',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20news%20anchor%20portrait%2C%20professional%20serious%20expression%2C%20suit%20and%20tie%2C%20newsroom%20background%20with%20screens%2C%20authoritative%20lighting&width=120&height=120&seq=eev-avatar-rsanchez&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Professional%20news%20broadcast%20studio%20with%20multiple%20video%20screens%20showing%20election%20maps%20and%20data%2C%20anchor%20desk%20with%20microphones%2C%20serious%20journalistic%20atmosphere%2C%20modern%20media%20control%20room%2C%20political%20coverage%20photography&width=1600&height=900&seq=eev-img-elecciones&orientation=landscape',
    cuentaRegresiva: '8 días',
    estado: 'proximamente',
    participantes: 15023,
    compartidos: 7890,
    comentarios: 10234,
    score: { asistir: 40, compartir: 25, comentar: 20, invitar: 25 },
    esDestacado: true,
    tags: ['política', 'elecciones', 'noticias', 'análisis'],
  },
  {
    id: 'eev-11',
    titulo: 'Festival de Talentos RFW — Gran Final',
    tipo: 'festival',
    descripcion: 'La gran final del Festival de Talentos RFW. 10 finalistas compiten en vivo por el gran premio: un contrato de grabación y una gira por 5 países. El público vota en tiempo real. Jurado de lujo con artistas invitados. La noche más esperada del talento emergente.',
    fecha: '2026-07-25',
    hora: '19:00 CST',
    radioNombre: 'La Mexicana FM',
    radioFrecuencia: '98.7 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Mexican%20radio%20station%20square%20logo%20design%2C%20sombrero%20and%20guitar%20icon%2C%20warm%20orange%20and%20green%20emblem%2C%20clean%20flat%20vector%20style&width=120&height=120&seq=eev-logo-mexicana&orientation=squarish',
    locutorNombre: 'Alejandro Ramírez',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Mexican%20male%20radio%20host%20portrait%2C%20friendly%20warm%20smile%2C%20casual%20professional%2C%20broadcast%20studio%20background%2C%20natural%20lighting&width=120&height=120&seq=eev-avatar-aramirez&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Grand%20talent%20show%20finale%20stage%20with%20dramatic%20spotlighting%2C%20golden%20confetti%20falling%2C%20judges%20panel%20at%20front%2C%20excited%20finalists%20on%20stage%2C%20large%20live%20audience%2C%20television%20production%20quality%2C%20entertainment%20spectacle%20photography&width=1600&height=900&seq=eev-img-talentos&orientation=landscape',
    cuentaRegresiva: '34 días',
    estado: 'proximamente',
    participantes: 9876,
    compartidos: 3456,
    comentarios: 2345,
    score: { asistir: 50, compartir: 25, comentar: 20, invitar: 35 },
    esDestacado: true,
    tags: ['talentos', 'final', 'concurso', 'premio'],
  },
  {
    id: 'eev-12',
    titulo: 'Entrevista: El Equipo Detrás de RFW — Cómo se Construye una Red Social de Radio',
    tipo: 'entrevista',
    descripcion: 'Por primera vez, el equipo fundador de RadioFrecuenciaWeb se sienta a contar la historia. Cómo nació la idea, los desafíos técnicos, la visión de comunidad, y qué viene para el futuro. Una conversación honesta sobre construir la red social donde viven las comunidades de radio.',
    fecha: '2026-07-01',
    hora: '11:00 CST',
    radioNombre: 'RFW Radio',
    radioFrecuencia: '87.00 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Official%20RFW%20network%20square%20logo%2C%20radio%20frequency%20waves%20emblem%2C%20warm%20red%20and%20amber%20gradient%2C%20professional%20broadcast%20identity%2C%20clean%20modern%20flat%20vector&width=120&height=120&seq=eev-logo-rfw&orientation=squarish',
    locutorNombre: 'Equipo RFW',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20tech%20startup%20team%20portrait%2C%20diverse%20group%20of%20people%2C%20modern%20office%20background%2C%20warm%20collaborative%20atmosphere%2C%20editorial%20photography&width=120&height=120&seq=eev-avatar-rfwteam&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Modern%20creative%20office%20studio%20with%20broadcast%20equipment%2C%20team%20collaboration%20around%20table%2C%20warm%20ambient%20lighting%2C%20radio%20production%20environment%2C%20startup%20culture%20photography%2C%20professional%20behind%20the%20scenes&width=1600&height=900&seq=eev-img-rfwteam&orientation=landscape',
    cuentaRegresiva: '10 días',
    estado: 'proximamente',
    participantes: 3456,
    compartidos: 1234,
    comentarios: 876,
    score: { asistir: 25, compartir: 20, comentar: 15, invitar: 15 },
    esDestacado: true,
    tags: ['RFW', 'equipo', 'historia', 'futuro'],
  },
  {
    id: 'eev-13',
    titulo: 'Especial Navideño en Julio — Aguinaldos y Villancicos',
    tipo: 'especial',
    descripcion: '¡Navidad llegó antes este año! Un especial temático donde los oyentes comparten sus tradiciones navideñas, cantan villancicos en vivo, y participan en el aguinaldo más grande de RFW con premios sorpresa. Porque la comunidad celebra cuando quiere.',
    fecha: '2026-07-18',
    hora: '16:00 CST',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=eev-logo-capital2&orientation=squarish',
    locutorNombre: 'Valentina Ríos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%2C%20warm%20confident%20smile%2C%20modern%20studio%20headphones%2C%20broadcast%20booth%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=120&height=120&seq=eev-avatar-vrios2&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Christmas%20in%20July%20themed%20radio%20studio%2C%20festive%20decorations%20with%20tropical%20twist%2C%20colorful%20lights%20and%20ornaments%2C%20palm%20tree%20with%20Christmas%20lights%2C%20warm%20cheerful%20holiday%20atmosphere%2C%20creative%20fun%20photography&width=1600&height=900&seq=eev-img-navidad&orientation=landscape',
    cuentaRegresiva: '27 días',
    estado: 'proximamente',
    participantes: 2890,
    compartidos: 1345,
    comentarios: 987,
    score: { asistir: 20, compartir: 15, comentar: 10, invitar: 15 },
    esDestacado: false,
    tags: ['navidad', 'especial', 'premios', 'comunidad'],
  },
  {
    id: 'eev-14',
    titulo: 'Concierto: Noche de Rock Nacional — 5 Bandas en Vivo',
    tipo: 'concierto',
    descripcion: 'Una noche dedicada al rock nacional. Cinco bandas emergentes se presentan en vivo desde el estudio de Rock Total Radio. Cada banda tiene 30 minutos para mostrar su música. El público vota y la banda ganadora recibe una sesión de grabación profesional.',
    fecha: '2026-07-10',
    hora: '19:00 CST',
    radioNombre: 'Rock Total Radio',
    radioFrecuencia: '95.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20square%20logo%2C%20electric%20guitar%20silhouette%2C%20bold%20red%20and%20black%20emblem%2C%20grunge%20style%20flat%20vector&width=120&height=120&seq=eev-logo-rock2&orientation=squarish',
    locutorNombre: 'Andrés Castillo',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Rock%20radio%20host%20male%20portrait%2C%20leather%20jacket%2C%20confident%20expression%2C%20studio%20with%20guitars%20on%20wall%2C%20edgy%20lighting&width=120&height=120&seq=eev-avatar-acastillo2&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Live%20rock%20band%20performing%20in%20radio%20studio%2C%20electric%20guitars%20and%20drum%20set%2C%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20intimate%20concert%20vibe%2C%20music%20performance%20photography%2C%20energetic%20rock%20atmosphere&width=1600&height=900&seq=eev-img-rocknacional&orientation=landscape',
    cuentaRegresiva: '19 días',
    estado: 'proximamente',
    participantes: 2345,
    compartidos: 890,
    comentarios: 654,
    score: { asistir: 30, compartir: 15, comentar: 10, invitar: 20 },
    esDestacado: false,
    tags: ['rock', 'bandas', 'nacional', 'competencia'],
  },
  {
    id: 'eev-15',
    titulo: 'Entrevista en Vivo: Dr. Pedro Gutiérrez — Salud Mental y Comunidad',
    tipo: 'entrevista',
    descripcion: 'El Dr. Pedro Gutiérrez, psicólogo y locutor de Radio Élite Digital, aborda el tema de la salud mental en tiempos de redes sociales. Cómo la comunidad de radio puede ser un espacio de contención. Los oyentes pueden hacer preguntas anónimas.',
    fecha: '2026-06-23',
    hora: '10:00 CST',
    radioNombre: 'Radio Élite Digital',
    radioFrecuencia: '96.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Digital%20elite%20radio%20station%20square%20logo%2C%20modern%20tech%20and%20broadcast%20fusion%2C%20sleek%20silver%20and%20teal%20emblem%2C%20professional%20clean%20flat%20vector&width=120&height=120&seq=eev-logo-elite&orientation=squarish',
    locutorNombre: 'Dr. Pedro Gutiérrez',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20doctor%20radio%20host%20portrait%2C%20professional%20calm%20expression%2C%20white%20coat%2C%20studio%20with%20bookshelves%2C%20warm%20natural%20lighting%2C%20editorial%20professional%20photography&width=120&height=120&seq=eev-avatar-pgutierrez&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Warm%20professional%20radio%20studio%20setup%20for%20health%20talk%20show%2C%20comfortable%20armchairs%2C%20plants%2C%20soft%20natural%20window%20lighting%2C%20calm%20therapeutic%20atmosphere%2C%20wellness%20podcast%20photography&width=1600&height=900&seq=eev-img-saludmental&orientation=landscape',
    cuentaRegresiva: '2 días',
    estado: 'proximamente',
    participantes: 4234,
    compartidos: 1876,
    comentarios: 1234,
    score: { asistir: 30, compartir: 20, comentar: 15, invitar: 20 },
    esDestacado: true,
    tags: ['salud', 'bienestar', 'psicología', 'comunidad'],
  },
  {
    id: 'eev-16',
    titulo: 'Especial: 100 Programas de Tardes con Vale — Celebración',
    tipo: 'especial',
    descripcion: 'Tardes con Vale llega a 100 programas al aire. Una celebración con los mejores momentos, invitados sorpresa, llamadas de oyentes que han sido parte de esta historia, y el anuncio de una nueva sección del programa. ¡No te lo pierdas!',
    fecha: '2026-06-24',
    hora: '17:00 CST',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=eev-logo-capital3&orientation=squarish',
    locutorNombre: 'Valentina Ríos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%2C%20warm%20confident%20smile%2C%20modern%20studio%20headphones%2C%20broadcast%20booth%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=120&height=120&seq=eev-avatar-vrios3&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Celebration%20themed%20radio%20studio%20with%20gold%20balloons%20and%20confetti%2C%20champagne%20glasses%20on%20broadcast%20desk%2C%20warm%20golden%20festive%20lighting%2C%20milestone%20celebration%20atmosphere%2C%20joyful%20event%20photography&width=1600&height=900&seq=eev-img-100programas&orientation=landscape',
    cuentaRegresiva: '3 días',
    estado: 'proximamente',
    participantes: 5678,
    compartidos: 2345,
    comentarios: 1876,
    score: { asistir: 25, compartir: 20, comentar: 15, invitar: 15 },
    esDestacado: true,
    tags: ['aniversario', 'celebración', 'Tardes con Vale'],
    programaNombre: 'Tardes con Vale',
  },
  {
    id: 'eev-17',
    titulo: 'Cobertura: Inauguración del Nuevo Estudio de RFW Radio',
    tipo: 'cobertura',
    descripcion: 'RFW Radio estrena estudio de última generación. Recorrido en vivo por las nuevas instalaciones, demostración del equipo de broadcast profesional, entrevistas con el equipo técnico, y la primera transmisión desde el nuevo estudio principal.',
    fecha: '2026-07-03',
    hora: '09:00 CST',
    radioNombre: 'RFW Radio',
    radioFrecuencia: '87.00 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Official%20RFW%20network%20square%20logo%2C%20radio%20frequency%20waves%20emblem%2C%20warm%20red%20and%20amber%20gradient%2C%20professional%20broadcast%20identity%2C%20clean%20modern%20flat%20vector&width=120&height=120&seq=eev-logo-rfw2&orientation=squarish',
    locutorNombre: 'Equipo RFW',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20tech%20startup%20team%20portrait%2C%20diverse%20group%20of%20people%2C%20modern%20office%20background%2C%20warm%20collaborative%20atmosphere%2C%20editorial%20photography&width=120&height=120&seq=eev-avatar-rfwteam2&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Modern%20professional%20broadcast%20studio%20interior%2C%20state%20of%20the%20art%20mixing%20console%20with%20LED%20screens%2C%20acoustic%20panels%20on%20walls%2C%20sleek%20contemporary%20design%2C%20warm%20professional%20lighting%2C%20high%20end%20production%20facility%20photography&width=1600&height=900&seq=eev-img-estudio&orientation=landscape',
    cuentaRegresiva: '12 días',
    estado: 'proximamente',
    participantes: 2345,
    compartidos: 876,
    comentarios: 543,
    score: { asistir: 20, compartir: 15, comentar: 10, invitar: 10 },
    esDestacado: false,
    tags: ['RFW', 'estudio', 'tecnología', 'inauguración'],
  },
  {
    id: 'eev-18',
    titulo: 'Festival Gastronómico RFW — Sabores del Mundo',
    tipo: 'festival',
    descripcion: 'Un festival que une gastronomía y radio. Chefs invitados cocinan en vivo mientras los locutores entrevistan y los oyentes votan el mejor plato. Transmisión desde el Mercado Central con degustaciones, recetas compartidas y premios para los oyentes que adivinan ingredientes secretos.',
    fecha: '2026-08-01',
    hora: '12:00 CST',
    radioNombre: 'La Kalle 99.9',
    radioFrecuencia: '99.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20square%20logo%2C%20neon%20microphone%20icon%2C%20vibrant%20pink%20and%20coral%20emblem%2C%20modern%20flat%20vector&width=120&height=120&seq=eev-logo-kalle2&orientation=squarish',
    locutorNombre: 'Diego Montenegro',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20male%20pop%20radio%20DJ%20portrait%2C%20stylish%20casual%20outfit%2C%20energetic%20smile%2C%20neon%20lit%20studio%20background%2C%20modern%20vibe&width=120&height=120&seq=eev-avatar-dmontenegro2&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20food%20festival%20at%20indoor%20market%20venue%2C%20chefs%20cooking%20at%20live%20stations%2C%20colorful%20fresh%20ingredients%20displayed%2C%20warm%20ambient%20lighting%2C%20people%20tasting%20and%20enjoying%2C%20culinary%20event%20photography%2C%20rich%20warm%20food%20tones&width=1600&height=900&seq=eev-img-gastronomico&orientation=landscape',
    cuentaRegresiva: '41 días',
    estado: 'proximamente',
    participantes: 3456,
    compartidos: 1234,
    comentarios: 765,
    score: { asistir: 35, compartir: 20, comentar: 15, invitar: 25 },
    esDestacado: false,
    tags: ['gastronomía', 'cocina', 'chefs', 'festival'],
  },
  {
    id: 'eev-19',
    titulo: 'Concierto Sinfónico de Películas — Música de Cine en Vivo',
    tipo: 'concierto',
    descripcion: 'La Orquesta Filarmónica Juvenil interpreta las bandas sonoras más icónicas del cine. De Star Wars a Harry Potter, de El Padrino a Titanic. Una noche mágica con pantalla gigante mostrando escenas mientras la orquesta toca en vivo.',
    fecha: '2026-07-28',
    hora: '20:00 CST',
    radioNombre: 'Radio Cultural CR',
    radioFrecuencia: '94.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Cultural%20radio%20station%20square%20logo%2C%20book%20and%20flower%20icon%2C%20elegant%20teal%20and%20gold%20emblem%2C%20classic%20flat%20vector%20style&width=120&height=120&seq=eev-logo-cultural2&orientation=squarish',
    locutorNombre: 'Mariana Vega',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20cultural%20radio%20host%20portrait%2C%20elegant%20warm%20smile%2C%20sophisticated%20casual%20style%2C%20artsy%20studio%20background%2C%20soft%20natural%20lighting&width=120&height=120&seq=eev-avatar-mvega2&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Grand%20symphony%20orchestra%20performing%20movie%20soundtracks%20on%20stage%2C%20large%20cinema%20screen%20showing%20film%20scenes%20behind%2C%20dramatic%20concert%20hall%20lighting%2C%20magical%20cinematic%20atmosphere%2C%20elegant%20cultural%20event%20photography&width=1600&height=900&seq=eev-img-cine&orientation=landscape',
    cuentaRegresiva: '37 días',
    estado: 'proximamente',
    participantes: 2345,
    compartidos: 987,
    comentarios: 543,
    score: { asistir: 35, compartir: 20, comentar: 10, invitar: 20 },
    esDestacado: false,
    tags: ['cine', 'orquesta', 'bandas sonoras', 'cultural'],
  },
  {
    id: 'eev-20',
    titulo: 'Especial Debate: El Futuro de la Radio Digital',
    tipo: 'especial',
    descripcion: 'Un debate con 5 locutores de diferentes géneros discutiendo hacia dónde va la radio en la era digital. Podcasts vs radio en vivo, interacción con oyentes, monetización, inteligencia artificial. Los oyentes participan con preguntas y votaciones en tiempo real.',
    fecha: '2026-07-22',
    hora: '15:00 CST',
    radioNombre: 'RFW Radio',
    radioFrecuencia: '87.00 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Official%20RFW%20network%20square%20logo%2C%20radio%20frequency%20waves%20emblem%2C%20warm%20red%20and%20amber%20gradient%2C%20professional%20broadcast%20identity%2C%20clean%20modern%20flat%20vector&width=120&height=120&seq=eev-logo-rfw3&orientation=squarish',
    locutorNombre: 'Panel de Locutores',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20radio%20hosts%20panel%20discussion%2C%20professional%20studio%20setting%2C%20engaged%20conversation%2C%20warm%20broadcast%20lighting%2C%20editorial%20group%20portrait&width=120&height=120&seq=eev-avatar-panel&orientation=squarish',
    ciudad: 'San José',
    pais: 'Costa Rica',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Professional%20panel%20discussion%20in%20modern%20broadcast%20studio%2C%20five%20diverse%20speakers%20at%20curved%20desk%20with%20microphones%2C%20audience%20visible%2C%20warm%20studio%20lighting%2C%20intellectual%20debate%20atmosphere%2C%20media%20conference%20photography&width=1600&height=900&seq=eev-img-debate&orientation=landscape',
    cuentaRegresiva: '31 días',
    estado: 'proximamente',
    participantes: 2890,
    compartidos: 1345,
    comentarios: 2345,
    score: { asistir: 25, compartir: 15, comentar: 20, invitar: 15 },
    esDestacado: false,
    tags: ['debate', 'futuro', 'digital', 'panel'],
  },
];

export const reglasEventosEnVivo = [
  {
    id: 1,
    titulo: 'Los eventos deben destacarse automáticamente',
    descripcion: 'Cuando un evento alcanza cierto umbral de participantes o está próximo a comenzar, se destaca automáticamente en el carrusel principal de TV App y en la sección de eventos de la landing. No requiere intervención manual.',
    icono: 'ri-sparkling-line',
    gradiente: 'from-rose-500 to-amber-500',
  },
  {
    id: 2,
    titulo: 'Cuenta regresiva siempre visible',
    descripcion: 'Cada evento muestra una cuenta regresiva precisa hasta el momento de inicio. Cuando llega a cero, el estado cambia automáticamente a En Vivo y se notifica a todos los participantes registrados.',
    icono: 'ri-timer-line',
    gradiente: 'from-emerald-500 to-teal-500',
  },
  {
    id: 3,
    titulo: 'Todo evento se comparte y se comenta',
    descripcion: 'Cada evento en vivo tiene sus propios contadores de participantes, compartidos y comentarios. Compartir no es solo difundir: es invitar a la comunidad a ser parte de algo más grande.',
    icono: 'ri-share-forward-line',
    gradiente: 'from-violet-500 to-purple-500',
  },
  {
    id: 4,
    titulo: 'La transmisión especial es prioridad',
    descripcion: 'Cuando un evento está en vivo, ocupa posición preferencial en el dial, en TV App y en todas las superficies de descubrimiento. La plataforma redirige atención hacia lo que está pasando ahora.',
    icono: 'ri-live-line',
    gradiente: 'from-red-500 to-rose-500',
  },
];

export const statsEventosEnVivo = {
  totalEventos: eventosEnVivo.length,
  eventosHoy: eventosEnVivo.filter(e => e.estado === 'hoy' || e.estado === 'en-vivo').length,
  totalParticipantes: eventosEnVivo.reduce((acc, e) => acc + e.participantes, 0),
  totalCompartidos: eventosEnVivo.reduce((acc, e) => acc + e.compartidos, 0),
  totalComentarios: eventosEnVivo.reduce((acc, e) => acc + e.comentarios, 0),
  eventosDestacados: eventosEnVivo.filter(e => e.esDestacado).length,
  scoreTotal: eventosEnVivo.reduce((acc, e) => acc + e.score.asistir + e.score.compartir + e.score.comentar + e.score.invitar, 0),
};

export const scoreEventosEnVivo = [
  { accion: 'Asistir al Evento', icono: 'ri-calendar-check-line', puntos: 30, gradiente: 'from-emerald-500 to-teal-500', descripcion: 'Confirmás tu presencia y te suma al contador de participantes' },
  { accion: 'Compartir el Evento', icono: 'ri-share-forward-line', puntos: 20, gradiente: 'from-violet-500 to-purple-500', descripcion: 'Difundís el evento en tus redes y traés más gente a la comunidad' },
  { accion: 'Comentar en Vivo', icono: 'ri-chat-3-line', puntos: 15, gradiente: 'from-amber-500 to-orange-500', descripcion: 'Participás de la conversación durante la transmisión en vivo' },
  { accion: 'Invitar a Otros', icono: 'ri-user-add-line', puntos: 25, gradiente: 'from-rose-500 to-pink-500', descripcion: 'Invitás directamente a otros oyentes a sumarse al evento' },
];

export function getEventosDestacados(): EventoEnVivo[] {
  return eventosEnVivo.filter(e => e.esDestacado);
}

export function getEventosPorTipo(tipo: string): EventoEnVivo[] {
  return eventosEnVivo.filter(e => e.tipo === tipo);
}

export function getEventosPorEstado(estado: string): EventoEnVivo[] {
  return eventosEnVivo.filter(e => e.estado === estado);
}

export function getEventosProximos(): EventoEnVivo[] {
  return eventosEnVivo.filter(e => e.estado === 'proximamente' || e.estado === 'hoy');
}

export function getMasParticipantes(): EventoEnVivo[] {
  return [...eventosEnVivo].sort((a, b) => b.participantes - a.participantes);
}

export function getMasCompartidos(): EventoEnVivo[] {
  return [...eventosEnVivo].sort((a, b) => b.compartidos - a.compartidos);
}

export function getMasComentados(): EventoEnVivo[] {
  return [...eventosEnVivo].sort((a, b) => b.comentarios - a.comentarios);
}

export function getMasProximos(): EventoEnVivo[] {
  return [...eventosEnVivo].filter(e => e.estado !== 'finalizado').sort((a, b) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime());
}

export function formatearNumero(n: number): string {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toString();
}